import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { AuthService } from './auth.service';

/**
 * Guard che impedisce l'accesso a pagine di autenticazione (login, register, etc.)
 * se l'utente è già autenticato
 */
export const noAuthGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      if (isAuthenticated) {
        // Se è autenticato, reindirizza alla home
        router.navigate(['/']);
        return false;
      }
      // Se non è autenticato, può accedere alla pagina di login
      return true;
    })
  );
};
